import { CFC } from "@api/types/cypress";
import { PropsWithChildren } from "react";

const Center: CFC<PropsWithChildren> = ({ children, cy }) => {
  return (
    <>
      <div className="Center" data-cy={cy}>
        {children}
      </div>
      {/* language=CSS */}
      <style jsx>
        {`
          .Center {
            text-align: center;
          }
        `}
      </style>
    </>
  );
};

export default Center;
